module.exports = "/assets/f66c7f1226c9c5b5b68d578b49d0b8f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/QS.png
// module id = 2885
// module chunks = 0